import React, { useEffect, useState } from 'react'
import Header from './Header'
import styled from 'styled-components'
import { getMethod } from '../Apis/apis'

const Container = styled.div`
    max-width: 480px;
    height: 100vh;
    overflow: scroll;
    opacity: 1;
    margin: 0 auto;
    position: relative;
    background-color: #1F2937;
`


const Watch = () => {
  const [data,setData] = useState();
  useEffect(()=>{
    (async()=>{
       const res = await getMethod('/about-us');
       if(res){
           if(res.data){
              if(res.data.length > 0){
                setData(res.data[0])
              }
           };
       };
    })();
 },[]);

  return (
    <Container>
      <Header status={true} />
      <iframe src={data && data.link} width="100%" height="90%" title="description"></iframe>
    </Container>
  )
}

export default Watch
